<template>
  <div class="downloads">
    <nav-headers />
    <div class="contents">
      <div class="in-banner">
        <div class="p-nav">
          <div class="p-title">
            <div class="p-1">DOWNLOAD</div>
            <div class="p-2">Home / Download</div>
          </div>
        </div>
        <img src="../assets/img/ny-03-DOWNLOAD.jpg" width="100%" height="auto" />
      </div>
      <div class="pageBox waps ">
        <div class="products-nav-centers">
          <div class="title">
            <div>Throughout the years, Yingcheng has made numerous models of manufacture of professional quality tools
              and hardware products, many of which are still in existence and occasionally are in need of service.
              Service parts list bulletins, wiring instructions and operators manuals can generally be obtained through
              this section of our website. </div>
            <div style="margin-top: 30px;">For an operators manual, service parts list bulletin and/or wiring
              instruction not found here through our website, please contact:</div>
            <div style="margin-top: 30px;font-size: 48px;font-weight: 600;color: #252525;">Yingcheng after-sales service
              – technical support</div>
            <div style="margin-top: 25px;font-size: 48px;font-weight: 600;color: #252525;">Via the contact us page.
            </div>
            <div style="margin-top: 30px;">When calling or e-mailing please be sure to include both the catalog no. /
              model no. And serial number from the tool's nameplate.</div>
          </div>
          <div class="mobile-title">
           <div> 
            Throughout the years, Yingcheng has made numerous models of manufacture of professional quality tools and hardware products, many of which are still in existence and occasionally are in need of service. Service parts list bulletins, wiring instructions and operators manuals can generally be obtained through this section of our website.
          </div>
          
          <div style="margin-top: 30px;">For an operators manual, service parts list bulletin and/or wiring
              instruction not found here through our website, please contact:</div>
            <div style="margin-top: 30px;font-size: 32px; line-height: 32px;font-weight: 600;color: #252525;">Yingcheng after-sales service
              – technical support</div>
            <div style="margin-top: 25px;font-size: 32px;line-height: 32px;font-weight: 600;color: #252525;">Via the contact us page.
            </div>
            <div style="margin-top: 30px;">When calling or e-mailing please be sure to include both the catalog no. /
              model no. And serial number from the tool's nameplate.</div>
          </div>
          <!--
          <div class="products-leixing">
            <span style="margin-right: 20px;" :class="{ 'active': newType == 1 }" @click="changeNew(1)">Product Video
            </span>
            /
            <span style="margin-left: 20px;" :class="{ 'active': newType == 2 }" @click="changeNew(2)">Company Video
              </span>
          </div>-->
        </div>
        <div class="products-centers">
          <div class="items" v-for="(val, index) in product" :key="index" @click="buy(val)">
            <div class="download-icon"></div>
            <div class="title">{{val.title}}</div>
          </div>
        </div>
        <div class="el-pages">
          <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
            :page-size="pageSize" layout="prev,pager,next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <nav-footer />

  </div>
</template>
<script>
//import NavHeaders from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: 'product',
  data() {
    return {
      newType: 1,
      dialogVisible: false,

      baseUrl: 'http://yingcheng.0576hs.com',
      id: this.$route.params.id,
      Factorys: [],
      currentPage: 1, // 当前页码
      pageSize: 8, // 每页显示的行数
      total: 0,

      showSlide: '', //控制动画效果
      list: [
        {}, {}, {}, {}, {}, {}
      ],
      product: [

      ], //商品信息
      // 轮播图插件
      swiperOption: {
        autoplay: true,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  },
  components: {
    NavHeaders: () => import('@/components/NavHeaders.vue'),
    NavFooter,
  },
  mounted() {
    this.getProductList();
    this.$nextTick(() => {
      this.handleAnimate()//初始化第一次加载时在视口内就执行动画
      addEventListener('scroll', this.handleAnimate);
    })
  },

  destroyed() {
    removeEventListener('scroll', this.handleAnimate);
  },
  created() {
    document.documentElement.scrollTop = "0px";
    setTimeout(this.handleAnimate, 1000);
  },
  methods: {
    handleClose() {
      this.$refs.videoPlayer.player.pause();
      this.dialogVisible = false
    },
    changeNew(val) {
      let self = this
      self.newType = val
      self.id = val
      self.getProductList()
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0;
        }
      })
    },
    handleCurrentChange(e) {
      let id = '14';
      this.currentPage = 1
      this.$api.mall.getDownloads({  limit: 9, page: e }).then((res) => {
        this.product = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 获取商品信息
    getProductList() {
      let id = '14';
      this.currentPage = 1
      this.$api.mall.getDownloads({ limit: 9, page: 1 }).then((res) => {
        this.product = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 购买
    buy(val) {
      this.dialogVisible = true
      val = this.product[0]
      //attachfile
      window.location.href = this.baseUrl+val.attachfile

      //let id = this.$route.params.id;
      // this.$router.push(`/newdetail/${val}`);
    },
    // 打开视频
    openVideo() {
      this.showSlide = 'slideDown';
    },
    // 关闭视频
    closeVideo() {
      this.showSlide = 'slideUp';
      setTimeout(() => {
        this.showSlide = '';
      }, 600);
    }
  }
};
</script>
<style lang="scss">
@media screen and (min-width: 0px) and (max-width:1024px) {
  .downloads {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
        .mobile-title{
         text-align: left;
        width: 90%;
        overflow: hidden;
        color: #676767;
        padding-top: 25px;
        padding-bottom: 25px;
        margin: 0px auto;
        box-sizing: border-box;
        line-height: 26px;
        }

        .title {
          display: none;
          text-align: left;
          width: 1600px;
          font-size: 15px;
          overflow: hidden;
          color: #676767;
          padding-top: 80px;
          padding-bottom: 80px;
          margin: 0px auto;
          box-sizing: border-box;
        }
      }

      .products-leixing {
        width: 288px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 90%;
        overflow: hidden;
        margin: 20px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        column-count: 1;
        column-gap: 35px;

        .items {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          padding-bottom: 30px;
          margin: 0px auto;
          position: relative;
          box-sizing: border-box;

          .download-icon {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 37px;
            height: 77px;
            background: url(../assets/img/download.png) no-repeat center;
            background-size: 27px;

          }

          .title {
            color: #fff;
            width: 100%;
            border-top: 1px solid #1c1c1c;
            border-bottom: 1px solid #1c1c1c;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 25px;
            padding-right:40px;
            padding-bottom: 25px;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;
            color: #1c1c1c;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
      img{
        width: 150%;
        height:auto
      }

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 100%;
          text-transform: uppercase;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 0px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 61px;
    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  .downloads {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
        
        .mobile-title{
          display:none  
        }

        .title {
          text-align: left;
          width: 1200px;
          overflow: hidden;
          color: #676767;
          padding-top: 80px;
          padding-bottom: 80px;
          margin: 0px auto;
          box-sizing: border-box;
        }
      }

      .products-leixing {
        width: 288px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 1200px;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        column-count: 2;
        column-gap: 55px;
        .items:hover{
          
          .title {
           color: #00959b;
          }
          .download-icon {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 77px;
            height: 77px;
            background: url(../assets/img/download\ \(1\).png) no-repeat center;
            background-size: 27px;

          }
        }
        .items {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          padding-bottom: 50px;
          margin: 0px auto;
          position: relative;
          box-sizing: border-box;
    

          .download-icon {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 77px;
            height: 77px;
            background: url(../assets/img/download.png) no-repeat center;
            background-size: 27px;

          }

          .title {
            color: #fff;
            width: 100%;
            border-top: 1px solid #1c1c1c;
            border-bottom: 1px solid #1c1c1c;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 25px;
            padding-right: 50px;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;
            color: #1c1c1c;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 258px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          text-transform: uppercase;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;
    }
  }

}

@media screen and (min-width: 1601px) and (max-width:8000px) {
  .downloads {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;

    //animate classs
    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }

    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }

    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;

      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
        
        .mobile-title{
          display:none  
        }

        .title {
          text-align: left;
          width: 1600px;
          overflow: hidden;
          color: #676767;
          padding-top: 80px;
          padding-bottom: 80px;
          margin: 0px auto;
          box-sizing: border-box;
        }
      }

      .products-leixing {
        width: 288px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;

        .active {
          color: #00959b;
        }

        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }

      .products-centers {
        width: 1600px;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        column-count: 2;
        column-gap: 55px;
        .items:hover{
          
          .title {
           color: #00959b;
          }
          .download-icon {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 77px;
            height: 77px;
            background: url(../assets/img/download\ \(1\).png) no-repeat center;
            background-size: 27px;

          }
        }
        .items {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          padding-bottom: 50px;
          margin: 0px auto;
          position: relative;
          box-sizing: border-box;
    

          .download-icon {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 77px;
            height: 77px;
            background: url(../assets/img/download.png) no-repeat center;
            background-size: 27px;

          }

          .title {
            color: #fff;
            width: 100%;
            border-top: 1px solid #1c1c1c;
            border-bottom: 1px solid #1c1c1c;
            overflow: hidden;
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 25px;
            padding-right: 50px;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;
            color: #1c1c1c;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;

        .p-title {
          width: 258px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          text-transform: uppercase;
          overflow: hidden;

          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }

          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }

    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;
    }
  }
}
</style>